jQuery(document).ready(function ($) {

  /* ===============================
     SELECTORS
  =============================== */
  const masterForm = $(".masterclss.sib-form form");
  const caseForm = $(".casestudy.sib-form form");
  const demoForm = $(".schedule__demo_form.sib-form form");
  const readyScaleForm = $(".ready_scale.ready_scal_form.sib-form form");
  const getAccessForm = $(".get_access_form.ready_scale_pop.sib-form form");

  if (!masterForm.length && !caseForm.length && !demoForm.length && !readyScaleForm.length && !getAccessForm.length) return;

  /* ===============================
     STORE ORIGINAL IDS
  =============================== */
  const masterId = masterForm.attr("id") || "masterclass-form";
  const demoId = demoForm.attr("id") || "demo-form";
  const caseId = caseForm.attr("id") || "casestudy-form";
  const readyId = readyScaleForm.attr("id") || "ready-scale-form";
  const accessId = getAccessForm.attr("id") || "get-access-form";

  if(masterForm.length) masterForm.attr("id", masterId);
  if(caseForm.length) caseForm.attr("id", caseId);
  if(demoForm.length) demoForm.attr("id", demoId);
  if(readyScaleForm.length) readyScaleForm.attr("id", readyId);
  if(getAccessForm.length) getAccessForm.attr("id", accessId);

  /* ===============================
     VALIDATION FUNCTIONS
  =============================== */
  function isNotEmpty(val) { return val && val.trim() !== ""; }
  function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email); }

  function validateForm(form, includePhone = false) {
    let valid = true;
    const name = form.find("input[name='FIRSTNAME']").val();
    const email = form.find("input[name='EMAIL']").val();
    const phone = includePhone ? form.find("input[name='SMS']").val() : null;

    form.find(".entry__error--primary").hide().text("");

    if (!isNotEmpty(name)) {
      form.find("input[name='FIRSTNAME']").closest(".form__entry").find(".entry__error--primary").text("Please enter your name.").show();
      valid = false;
    }
    if (!isNotEmpty(email) || !isValidEmail(email)) {
      form.find("input[name='EMAIL']").closest(".form__entry").find(".entry__error--primary").text("Please enter a valid email.").show();
      valid = false;
    }
    if(includePhone && !isNotEmpty(phone)) {
      form.find("input[name='SMS']").closest(".form__entry").find(".entry__error--primary").text("Please enter your phone number.").show();
      valid = false;
    }

    return valid;
  }

  /* ===============================
     AJAX SUBMIT
  =============================== */
 

  // One DataCX event per form, based on the actual .sib-form wrapper.
  const DATACX_FORMS = [
    { selector: ".schedule__demo_form", source: "schedule__demo_form", event: "schedule_demo_form_submitted" },
    { selector: ".masterclss", source: "masterclss", event: "masterclass_form_submitted" },
    { selector: ".casestudy", source: "casestudy", event: "casestudy_form_submitted" },
    { selector: ".ready_scale", source: "ready_scale", event: "ready_scale_form_submitted" },
    { selector: ".get_access_form", source: "get_access_form", event: "get_access_form_submitted" }
  ];

  function getDataCXConfig(form) {
    const wrapper = form.closest(".sib-form");
    return DATACX_FORMS.find(item => wrapper.is(item.selector)) || null;
  }

  // Retain an anonymous ID for the visitor instead of generating one on every submit.
  function getDataCXAnonymousId() {
    try {
      const key = "var80_datacx_anonymous_id";
      let id = localStorage.getItem(key);
      if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem(key, id);
      }
      return id;
    } catch (e) {
      return crypto.randomUUID();
    }
  }

  async function sendDataCXFormEvent(formConfig, formData) {
    const endpoint = "https://cdp.d8a.cx/v1/track";
    // IMPORTANT: This key is visible in storefront JS. Use only an approved
    // public/write-only key. A private key belongs on a server-side proxy.
    const authorization = "Basic ZnlvenhwZ2loaXVnemh2Z3Bmb3dpYmNkZWF4bnB2cmE6";
    const anonymousId = getDataCXAnonymousId();
    const now = new Date().toISOString();
    const phoneDigits = (formData.phone || "").replace(/\D/g, "");
    const countryCode = formData.countryCode || "";
    const phone = phoneDigits
      ? (phoneDigits.startsWith(countryCode.replace(/\D/g, "")) ? "+" + phoneDigits : countryCode + phoneDigits)
      : "";

    const payload = {
      event: formConfig.event,
      type: "track",
      channel: "web",
      userId: "",
      anonymousId,
      messageId: crypto.randomUUID(),
      originalTimestamp: now,
      sentAt: now,
      integrations: { All: true },
      properties: {
        form_source: formConfig.source,
        firstName: formData.name,
        email: formData.email,
        phone,
        company_name: formData.company,
        business_type: formData.business_stage,
        inquiry_type: formData.inquiry_type,
        message: formData.message
      },
      context: {
        traits: {
          email: formData.email,
          action_name: formConfig.event
        },
        sessionId: Date.now(),
        locale: navigator.language,
        userAgent: navigator.userAgent,
        page: {
          title: document.title,
          url: window.location.href,
          path: window.location.pathname,
          referrer: document.referrer || "$direct"
        }
      }
    };

    console.info("[DataCX] Sending", formConfig.event, payload.properties);
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        mode: "cors",
        headers: {
          accept: "application/json",
          authorization,
          "content-type": "application/json;charset=UTF-8",
          anonymousid: btoa(anonymousId),
          sentat: now
        },
        body: JSON.stringify(payload)
      });
      const responseText = await response.text();
      if (!response.ok) throw new Error("HTTP " + response.status + ": " + responseText);
      console.info("[DataCX] SUCCESS", formConfig.event, response.status, responseText);
    } catch (err) {
      console.error("[DataCX] FAILED", formConfig.event, err);
    }
  }

  function submitFormAjax(form, successSel, errorSel) {
    if (form.data("brevoSubmitting")) return;
    form.data("brevoSubmitting", true);

    form.find("#success-message, #error-message").hide();

    // Get values BEFORE reset
    const formData = {
        name: form.find("input[name='FIRSTNAME']").val() || "",
        email: form.find("input[name='EMAIL']").val() || "",
        phone: form.find("input[name='SMS']").val() || "",
        company: form.find("input[name='COMPANY_NAME']").val() || "",
        business_stage: form.find("select[name='BUSINESS_TYPE'] option:selected").text().trim() || "",
        inquiry_type: form.find("select[name='INQURY_TYPE'] option:selected").text().trim() || "",
        message: form.find("input[name='MESSAGE'], textarea[name='MESSAGE']").val() || "",
        countryCode: form.find("select[name='SMS__COUNTRY_CODE'], input[name='SMS__COUNTRY_CODE']").val() || ""
    };

    fetch(form.attr("action"), {
        method: "POST",
        body: new FormData(form[0]),
        mode: "no-cors"
    })
    .then(() => {

        // Show Success Message
        $(successSel).show();

        // -----------------------------
        // Google Tag Manager DataLayer
        // -----------------------------
        const datacxForm = getDataCXConfig(form);
        const formSource = datacxForm ? datacxForm.source : "unknown";
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: "brevo_form_submit",

            form_source: formSource,

            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            company: formData.company,
            business_stage: formData.business_stage,
            inquiry_type: formData.inquiry_type
        });

        console.log("DataLayer Event Fired", formData);

        // -----------------------------
        // Facebook Pixel Lead Event
        // -----------------------------
        if (typeof fbq === "function") {

            fbq("track", "Lead", {
                content_name: form.attr("id")
            });

            console.log("Facebook Lead Event Fired");
        } else {
            console.warn("Facebook Pixel not found");
        }

        // DataCX: wait until the form's success panel has been displayed.
        // This matches the successful Schedule Demo UI flow for all five forms.
        // NOTE: because the Brevo request is no-cors, this is a UI-success
        // event, not independent verification of acceptance by Brevo.
        if (datacxForm) {
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    const successPanel = $(successSel).first();
                    if (successPanel.length && successPanel.is(':visible')) {
                        console.info('[DataCX] Success UI displayed:', datacxForm.event);
                        void sendDataCXFormEvent(datacxForm, formData);
                    } else {
                        console.warn('[DataCX] Success UI not visible; skipped:', datacxForm.event);
                    }
                });
            });
        }

        // -----------------------------
        // Reset Form
        // -----------------------------
        form[0].reset();

        setTimeout(function () {

            form.find('input[name="SMS__COUNTRY_CODE"]').val('+91');

            form.find('.sib-sms-select__label-text').text('India');

            form.find('.sib-sms-select__title .sib-flag')
                .attr('class', 'sib-flag sib-flag-in');

        }, 100);

    })
    .catch((err) => {

        console.error("Brevo Submit Error", err);

        $(errorSel).show();

    })
    .finally(() => form.data("brevoSubmitting", false));

}

  /* ===============================
     FORM BUTTON CLICK HANDLER
  =============================== */
  $(document).on("click", ".masterclss.sib-form button[type='submit'], .masterclss.sib-form input[type='submit']", function(e){
    e.preventDefault();
    if(masterForm.length){
      masterForm.attr("id", masterId);
      if(caseForm.length) caseForm.attr("id", "case-temp");
      if(demoForm.length) demoForm.attr("id", "demo-temp");
      if(readyScaleForm.length) readyScaleForm.attr("id", "ready-scale-temp");
      if(getAccessForm.length) getAccessForm.attr("id", "access-temp");
      if(validateForm(masterForm)) submitFormAjax(masterForm, ".masterclss #success-message", ".masterclss #error-message");
    }
  });

  $(document).on("click", ".casestudy.sib-form button[type='submit'], .casestudy.sib-form input[type='submit']", function(e){
    e.preventDefault();
    if(caseForm.length){
      caseForm.attr("id", caseId);
      if(masterForm.length) masterForm.attr("id", "master-temp");
      if(demoForm.length) demoForm.attr("id", "demo-temp");
      if(readyScaleForm.length) readyScaleForm.attr("id", "ready-scale-temp");
      if(getAccessForm.length) getAccessForm.attr("id", "access-temp");
      if(validateForm(caseForm)) submitFormAjax(caseForm, ".casestudy #success-message", ".casestudy #error-message");
    }


      let valid = true;

    // Existing validation
if(!validateForm(caseForm, true)){
    valid = false;
}
    // Phone format validation
const phone = caseForm.find("input[name='SMS']").val().trim();
const countryCode = caseForm.find("select[name='SMS__COUNTRY_CODE']").val();

if(!phone){
    caseForm
      .find("input[name='SMS']")
      .closest(".form__entry")
      .find(".entry__error--primary")
      .text("Please enter your phone number.")
      .show();

    valid = false;
}
else if(countryCode === "+91" && !/^[6-9]\d{9}$/.test(phone)){
    caseForm
      .find("input[name='SMS']")
      .closest(".form__entry")
      .find(".entry__error--primary")
      .text("Please enter a valid Indian mobile number.")
      .show();

    valid = false;
}
 if(!valid){
        return false;
    }
  });

$(document).on("click", ".schedule__demo_form.sib-form button[type='submit'], .schedule__demo_form.sib-form input[type='submit']", function(e){

    e.preventDefault();

    if(!demoForm.length) return;

    demoForm.attr("id", demoId);
    if(masterForm.length) masterForm.attr("id", "master-temp");
if(caseForm.length) caseForm.attr("id", "case-temp");
if(readyScaleForm.length) readyScaleForm.attr("id", "ready-scale-temp");
    if(readyScaleForm.length){
        readyScaleForm.attr("id", "ready-scale-temp");
    }

    // Reset errors
    demoForm.find(".entry__error--primary").hide().text("");

    let valid = true;

    // Existing validation
if(!validateForm(demoForm, true)){
    valid = false;
}
    // Phone format validation
const phone = demoForm.find("input[name='SMS']").val().trim();
const countryCode = demoForm.find("select[name='SMS__COUNTRY_CODE']").val();

if(!phone){
    demoForm
      .find("input[name='SMS']")
      .closest(".form__entry")
      .find(".entry__error--primary")
      .text("Please enter your phone number.")
      .show();

    valid = false;
}
else if(countryCode === "+91" && !/^[6-9]\d{9}$/.test(phone)){
    demoForm
      .find("input[name='SMS']")
      .closest(".form__entry")
      .find(".entry__error--primary")
      .text("Please enter a valid Indian mobile number.")
      .show();

    valid = false;
}

    // Business Stage validation
    const businessType = demoForm.find("select[name='BUSINESS_TYPE']").val();

    if(!businessType){
        demoForm
          .find("select[name='BUSINESS_TYPE']")
          .closest(".form__entry")
          .find(".entry__error--primary")
          .text("Please select a business stage.")
          .show();

        valid = false;
    }

    // Inquiry Type validation
    const inquiryType = demoForm.find("select[name='INQURY_TYPE']").val();

    if(!inquiryType){
        demoForm
          .find("select[name='INQURY_TYPE']")
          .closest(".form__entry")
          .find(".entry__error--primary")
          .text("Please select an inquiry type.")
          .show();

        valid = false;
    }

    

    if(!valid){
        return false;
    }

    submitFormAjax(
        demoForm,
        ".schedule__demo_form #success-message",
        ".schedule__demo_form #error-message"
    );

});

  $(document).on("click", ".ready_scale.sib-form button[type='submit'], .ready_scale.sib-form input[type='submit']", function(e){
    e.preventDefault();
    if(readyScaleForm.length){
      readyScaleForm.attr("id", readyId);
      if(masterForm.length) masterForm.attr("id", "master-temp");
      if(caseForm.length) caseForm.attr("id", "case-temp");
      if(demoForm.length) demoForm.attr("id", "demo-temp");
      if(getAccessForm.length) getAccessForm.attr("id", "access-temp");
      if(validateForm(readyScaleForm, true)) submitFormAjax(readyScaleForm, ".ready_scale #success-message", ".ready_scale #error-message");
    }
  });


    $(document).on("click", ".get_access_form.sib-form button[type='submit'], .get_access_form.sib-form input[type='submit']", function(e){
    e.preventDefault();
    if(getAccessForm.length){
      getAccessForm.attr("id", accessId);
      if(masterForm.length) masterForm.attr("id", "master-temp");
      if(caseForm.length) caseForm.attr("id", "case-temp");
      if(demoForm.length) demoForm.attr("id", "demo-temp");
      if(readyScaleForm.length) readyScaleForm.attr("id", "ready-scale-temp");
      if(validateForm(getAccessForm, true)) submitFormAjax(getAccessForm, ".get_access_form #success-message", ".get_access_form #error-message");
    }
  });

});

$(document).ready(function(){

  $(document).on('input','input[name="SMS"]',function(){
      this.value = this.value.replace(/\D/g,'').slice(0,10);
  });

  $(document).on('change input','input[name="SMS__COUNTRY_CODE"]',function(){
      $(this).val('+91');
  });

  $('input[name="SMS__COUNTRY_CODE"]').val('+91');

});



jQuery(document).ready(function($) {
  // Smooth scroll for #v80-contact links
  $("a[href='#v80-contact']").on("click", function(e) {
    e.preventDefault(); // Prevent default jump
    var target = $($(this).attr("href")); // Get target section
    if(target.length) {
      $("html, body").animate({
        scrollTop: target.offset().top
      }, 1000); // 800ms scroll duration, adjust as needed
    }
  });
});
